import { styled } from '@mui/material/styles';
import Button, { ButtonProps } from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { ReactElement } from 'react';

// TODO discuss overall styles of buttons + whether shrink to icon button should still be used with Pedro + Move to component library
const StyledAppBaseButton = styled(Button)<ButtonProps>(() => ({
  borderRadius: '22.5px',
  height: '45px',
  letterSpacing: '1.5px',
  fontFamily: 'kingspanBrownTT-Bold',
  fontSize: '14px',
  paddingLeft: '24px',
  paddingRight: '24px',
  paddingTop: '15px',
  paddingBottom: '15px',
  boxShadow: '0px',
  width: 'fit-content',
}));

type AppBaseButtonProps = ButtonProps & {
  isLoading?: boolean;
  component?: string;
  disabled?: boolean;
};

export function AppBaseButton({ isLoading, ...props }: AppBaseButtonProps): ReactElement | null {
  return (
    <StyledAppBaseButton {...props}>
      <div style={{ position: 'relative', bottom: '-0.15em' }}>
        {isLoading ? <CircularProgress data-testid="loading-circle" size={25} sx={{ color: 'white' }} /> : props.children}
      </div>
    </StyledAppBaseButton>
  );
}
